<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex md12 v-for="wk in workers" :key="wk.description">
        <worker-detail :worker_detail="wk" :token="getConsumer(w_type).token" :w_type="w_type" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WorkerDetail from '@/components/Workers/WorkerDetail'
import { mapGetters } from 'vuex'

export default {
  props: ['user', 'w_type'],
  components: {
    WorkerDetail
  },
  computed: {
    ...mapGetters(['getConsumer', 'getUserId', 'getServer', 'getTokenHeader'])
  },
  data() {
    return {
      workers: [],
      formload: true
    }
  },
  created() {
    const consumer = this.getConsumer(this.w_type)
    this.$http
      .get(`${window.location.protocol}//${this.w_type}.trawlingweb.com/workers?token=${consumer.token}`)
      .then(data => {
        this.workers = data.data.response.workers
        this.formload = false
      })
      .catch(() => {
        // PROBLEM
      })
  },
  methods: {}
}
</script>
